import React from "react";
import {
  AutocompleteInput,
  Create,
  ReferenceInput,
  SimpleForm,
} from "react-admin";
// Local
import { sortBy } from "../../react-admin";

export const MsgTemplateCreate = props => {
  // Only select the type, the MsgTemplateEdit form will do the rest.
  return (
    <Create {...props}>
      <SimpleForm redirect="edit">
        <ReferenceInput
          source="msgTypeId"
          reference="msg_types"
          isRequired
          label="Message type"
          fullWidth
          sort={sortBy.nameAsc}
        >
          <AutocompleteInput optionText="name" />
        </ReferenceInput>
      </SimpleForm>
    </Create>
  );
};
